module.exports = __webpack_public_path__ + "static/media/lehotsky.39d864f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/vychovakzivotu/resources/lehotsky.jpg
// module id = 492
// module chunks = 0